




















































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {DateTime} from '@/utils/DateTime';
import {Notify} from '@/utils/Notify';

import {ISystemInfoService} from '@/services/system/IInfo.service';

import SystemInfoStore from '@/store/system/SystemInfo.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
  export default class SystemInfoGeneral extends Mixins<BaseComponent>(BaseComponent) {
  private DateTime = DateTime;

  @Inject(Symbol.for('ISystemInfoService'))
  private systemInfoService!: ISystemInfoService;

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private lastUpdateTime: Date | undefined;

  private systemTime: Date = new Date();
  private uptime: number = 0;

    private refreshTimerHandle: any;

    private startTime: Date | undefined;

    private async mounted() {
      await this.refresh();

      this.computeTime();

      this.refreshTimerHandle = setInterval(() => {
        this.computeTime();
      }, 1000);
    }

    private beforeDestroy() {
      clearInterval(this.refreshTimerHandle);
    }

    private async refresh() {
      this.setLoading();
      try {
        await this.systemInfoStore.fetchSystemInfo();
        this.logger.info(`System info data fetched`, this.systemInfoStore.SystemInfo);

        this.lastUpdateTime = new Date();

        if (this.systemInfoStore.SystemInfo) {
          this.startTime = new Date(new Date().getTime() - (this.systemInfoStore.SystemInfo.Uptime / 1000000));
        }
      } catch (error) {
        Notify.Error(this.logger, `Could not fetch system info data`, error);
      }

      try {
        await this.systemInfoStore.fetchSoftwareDetails();
        this.logger.info(`System software details fetched`, this.systemInfoStore.SoftwareDetails);
      } catch (error) {
        Notify.Error(this.logger, `Could not fetch system software details`, error);
      }

      this.setLoaded();
    }

    private async copy(text: string) {
      await navigator.clipboard.writeText(text);

      Notify.Info(this.logger, 'The text has been copied to your clipboard');
    }

    private computeTime() {
      if (this.lastUpdateTime !== undefined) {
        if (this.systemInfoStore.SystemInfo) {
          this.systemTime = new Date(this.systemInfoStore.SystemInfo.DateTime.getTime() + (new Date().getTime() - this.lastUpdateTime.getTime()));
          this.logger.debug(`System time updated`, this.systemTime);
        }
      }

      if (this.startTime !== undefined) {
        this.uptime = Math.floor((new Date().getTime() - this.startTime.getTime()) / 1000);
        this.logger.debug(`Uptime updated`, this.startTime);
      }
    }

  }
